import { Size } from '../../../core/enums';
import makeAtom from '../../../core/makeAtom';
import type { Theme } from '../../../core/types';
import styles from './index.module.less';

interface Props {
  className?: string;
  theme?: Theme;
  src: string;
  alt: string;
  $size?: Size;
  $withShadowHover?: boolean;
  qeId?: string;
}

export const CardArt = makeAtom<Props>({
  name: 'CardArt',
  defaultProps: {
    Component: 'img',
    $size: Size.MD,
  },
  rootClass: styles.root,
  styles,
  disallowCustomComponent: true,
});
